module.exports = __webpack_public_path__ + "img/20_year_medallion.1a28ee4a.png";